import { ArrowRight, ChevronDown, Info, TrendingUp } from 'lucide-react';
import { useState } from 'react';

const BoostATSCard = ({ onGetStarted }: { onGetStarted: () => void }) => {
  const [atsInfoOpen, setAtsInfoOpen] = useState(false);

  return (
    <div
      onClick={onGetStarted}
      className='relative mb-6 cursor-pointer overflow-hidden rounded-2xl px-7 py-5 shadow-md transition-all duration-300 hover:shadow-lg'
      style={{
        background:
          'linear-gradient(135deg, #1D2C61 0%, #3956D1 40%, #4668F4 100%)'
      }}
    >
      <div
        className='pointer-events-none absolute inset-0 opacity-[0.07]'
        style={{
          backgroundImage: `radial-gradient(circle at 20% 80%, #fff 1px, transparent 1px),
                            radial-gradient(circle at 80% 20%, #fff 1px, transparent 1px),
                            radial-gradient(circle at 60% 60%, #fff 0.5px, transparent 0.5px)`,
          backgroundSize: '40px 40px, 60px 60px, 30px 30px'
        }}
      />

      <div className='pointer-events-none absolute -right-8 -top-12 h-[180px] w-[180px] rounded-full bg-beta/15 blur-[40px]' />
      <div className='pointer-events-none absolute bottom-[-60px] left-[60px] h-[120px] w-[120px] rounded-full bg-brand/20 blur-[30px]' />

      <div
        className='pointer-events-none absolute -top-2.5 right-10 h-[60px] w-[200px] -rotate-[15deg]'
        style={{
          background:
            'linear-gradient(90deg, transparent, rgba(255,255,255,0.04), transparent)'
        }}
      />

      <div className='relative z-[1] flex items-center gap-4'>
        <div className='flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-xl border border-white/15 bg-white/[0.12] backdrop-blur-sm'>
          <TrendingUp size={22} className='text-white' />
        </div>

        <div className='min-w-0 flex-1'>
          <h3 className='mb-0.5 text-base font-bold leading-tight text-white'>
            Boost Your ATS Score
          </h3>
          <p className='text-[13px] leading-normal text-white/70'>
            Analyse your resume against a job description to get keyword
            suggestions and improve your ATS compatibility.
          </p>
        </div>

        <button
          onClick={e => {
            e.stopPropagation();
            onGetStarted();
          }}
          className='inline-flex shrink-0 animate-pulse-glow-green items-center gap-2 rounded-lg bg-green-500 px-6 py-2.5 text-sm font-bold text-white transition-all duration-200 hover:brightness-110'
        >
          Get ATS Report
          <span className='inline-flex animate-bounce-right'>
            <ArrowRight size={15} />
          </span>
        </button>
      </div>

      <div style={{ position: 'relative', zIndex: 1, marginTop: 14 }}>
        <button
          onClick={e => {
            e.stopPropagation();
            setAtsInfoOpen(!atsInfoOpen);
          }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: 8,
            padding: '6px 14px',
            cursor: 'pointer',
            color: 'rgba(255,255,255,0.8)',
            fontSize: 11,
            fontWeight: 600,
            fontFamily: 'inherit'
          }}
        >
          <Info size={12} className='text-white/70' />
          What is ATS?
          <span
            style={{
              transform: atsInfoOpen ? 'rotate(180deg)' : 'none',
              transition: 'transform 0.2s',
              display: 'inline-flex'
            }}
          >
            <ChevronDown size={12} className='text-white/60' />
          </span>
        </button>

        {atsInfoOpen && (
          <div
            className='animate-fade-slide-in'
            style={{
              marginTop: 10,
              padding: '14px 16px',
              borderRadius: 10,
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.1)',
              fontSize: 12,
              lineHeight: 1.7,
              color: 'rgba(255,255,255,0.85)'
            }}
          >
            <strong style={{ color: '#fff' }}>
              ATS (Applicant Tracking System)
            </strong>{' '}
            is software used by companies to automatically scan and filter
            resumes before a recruiter sees them. Over 75% of resumes are
            rejected by ATS before reaching human eyes. A higher score means
            your resume better matches the job&apos;s requirements.
          </div>
        )}
      </div>
    </div>
  );
};

export default BoostATSCard;
